<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
              <b-overlay :show="loading">
                <b-row>
                  <b-col lg="12" sm="12">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                      <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                        <b-row>
                          <b-col lg="6" sm="6">
                            <ValidationProvider name="Product Type" vid="type_id" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="type_id"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('production_configuration.product_type')}}
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="formData.type_id"
                                    :options="productTypeList"
                                    :disabled="isDisable"
                                    id="type_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="6">
                            <ValidationProvider name="Category Name" vid="category_id" rules="required|min_value:1">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="category_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('production_configuration.category_name')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="formData.category_id"
                                  :disabled="isDisable"
                                  :options="categoryList"
                                  id="category_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="6">
                            <ValidationProvider name="Sub-Category" vid="sub_category_id">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="sub_category_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('production_configuration.sub_category_name')}}
                                </template>
                                <b-form-select
                                  plain
                                  v-model="formData.sub_category_id"
                                  :disabled="isDisable"
                                  :options="subCategoryList"
                                  id="sub_category_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="6">
                            <ValidationProvider name="Product Name" vid="product_id" rules="required|min_value:1">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="product_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('production_configuration.product_name')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="formData.product_id"
                                  :options="productList"
                                  :disabled="isDisable"
                                  id="product_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="6">
                            <ValidationProvider name="Effective Date" vid="created_date"  rules="required">
                              <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="created_date"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('production_configuration.effective_date')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  id="created_date"
                                  data-vv-as="effective_date"
                                  v-model="formData.created_date"
                                  :disabled="isDisable"
                                  class="created_date"
                                  placeholder="Y-m-d"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-overlay :show="unitLoad">
                              <table class="table table-bordered">
                                <tr class="bg-light">
                                  <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                  <th>{{ $t('production_configuration.unit_name') }}</th>
                                  <th>{{ $t('production_configuration.value_price') }}</th>
                                  <th>{{ $t('production_configuration.dealer_price') }}</th>
                                  <th>{{ $t('production_configuration.recommended_price') }}</th>
                                  <th>{{ $t('production_configuration.retailer_price') }}</th>
                                </tr>
                                <tr v-for="(unit, index) in unitList" :key="index">
                                  <td>{{ $n(index + 1) }}</td>
                                  <td>{{ getUnitName(unit.unit_id) }}</td>
                                  <td>
                                    <ValidationProvider name="Value price" :vid="'value_price'+index" rules="required">
                                        <b-form-group
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            v-model="unit.value_price"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider name="Dealer Price" :vid="'dealer_price'+index" rules="required">
                                        <b-form-group
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            v-model="unit.dealer_price"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider name="Recommended Price" :vid="'recommended_price'+index" rules="required">
                                        <b-form-group
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            v-model="unit.recommended_price"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <ValidationProvider name="Retailer price" :vid="'retailer_price'+index" rules="required">
                                        <b-form-group
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            v-model="unit.retailer_price"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                              <hr>
                              <table class="table table-bordered">
                                <tr class="bg-warning">
                                  <th colspan="7" class="text-center text-dark">{{ $i18n.locale === 'en' ? 'Previous Price Information' : 'পূর্ববর্তী মূল্য তথ্য' }}</th>
                                </tr>
                                <tr class="bg-light">
                                  <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                  <th>{{ $t('production_configuration.unit_name') }}</th>
                                  <th>{{ $t('production_configuration.value_price') }}</th>
                                  <th>{{ $t('production_configuration.dealer_price') }}</th>
                                  <th>{{ $t('production_configuration.recommended_price') }}</th>
                                  <th>{{ $t('production_configuration.retailer_price') }}</th>
                                  <th>{{ $t('production_configuration.effective_date') }}</th>
                                </tr>
                                <tr v-for="(unit, index) in previousPrices" :key="index">
                                  <td>{{ $n(index + 1) }}</td>
                                  <td>{{ getUnitName(unit.unit_id) }}</td>
                                  <td>{{ unit.value_price }}</td>
                                  <td>{{ unit.dealer_price }}</td>
                                  <td>{{ unit.recommended_price }}</td>
                                  <td>{{ unit.retailer_price }}</td>
                                  <td>{{ unit.created_date | dateFormat }}</td>
                                </tr>
                              </table>
                            </b-overlay>
                          </b-col>
                        </b-row>
                        <div class="row">
                          <div class="col-sm-3"></div>
                          <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                          </div>
                        </div>
                      </b-form>
                    </ValidationObserver>
                  </b-col>
                </b-row>
              </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '../../../../../config/api_config'
import { getPriceById, priceInfoStore, priceInfoUpdate } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      formData: {
        type_id: 0,
        category_id: 0,
        sub_category_id: 0,
        product_id: 0,
        created_date: ''
      },
      isDisable: false,
      subCategoryList: [],
      productList: [],
      unitList: [],
      unitLoad: false,
      loading: false,
      previousPrices: []
    }
  },
  computed: {
    productTypeList: function () {
      return this.productCommonObj.productTypeList.map(item => {
        return { value: item.value, text: this.$i18n.locale === 'bn' ? item.text_bn : item.text_en }
      })
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    if (this.id) {
      const tmp = this.getProductData()
      this.formData = tmp
      this.getPriceListById(tmp.product_id)
      this.isDisable = true
    }
  },
  mounted () {
    flatpickr('.created_date', {})
  },
  watch: {
    'formData.type_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productList = this.getProductListByType(newVal)
      }
    },
    'formData.category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.subCategoryList = this.getSubCatList(newVal)
        this.productList = this.getProductListByCat(newVal)
      }
    },
    'formData.sub_category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productList = this.getProductList(newVal)
      }
    },
    'formData.product_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.unitList = this.getUnitList(newVal)
        if (!this.id) {
          this.getPriceListById(newVal)
        }
      }
    }
  },
  methods: {
    getProductData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    async saveData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }

      const insertData = {
        product_id: this.formData.product_id,
        created_date: this.formData.created_date,
        unitList: this.unitList
      }
      this.loading = true
      if (this.id) {
        insertData.oldUnitList = this.previousPrices
        result = await RestApi.putData(productionServiceBaseUrl, `${priceInfoUpdate}/${this.id}`, insertData)
      } else {
        result = await RestApi.postData(productionServiceBaseUrl, priceInfoStore, insertData)
      }
      this.loading = false
      loadingState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadingState)

      if (result.success) {
        this.$store.dispatch('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$bvModal.hide('modal-4')
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    getSubCatList (catId) {
      return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId)
    },
    getProductListByCat (catId) {
      const prodList = this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId)
      if (this.formData.type_id) {
        return prodList.filter(el => el.type_id === parseInt(this.formData.type_id))
      }
      return prodList
    },
    getProductList (subCatId) {
      const prodList = this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId)
      if (this.formData.type_id) {
        return prodList.filter(el => el.type_id === parseInt(this.formData.type_id))
      }
      return prodList
    },
    getProductListByType (newVal) {
      if (newVal) {
        let dList = []
        if (this.formData.category_id) {
          dList = this.getProductListByCat(this.formData.category_id)
        }
        if (this.formData.sub_category_id) {
          dList = this.getProductList(this.formData.sub_category_id)
        }
        return dList
      }
      return []
    },
    getUnitList (proId) {
      const proUnitList = this.productCommonObj.productUnitList.filter(item => item.product_id === proId && item.status === 1)
      return proUnitList.map(item => {
        return Object.assign({}, item, {
          value_price: '',
          dealer_price: '',
          recommended_price: '',
          retailer_price: ''
        })
      })
    },
    getUnitName (unitId) {
      const unit = this.productCommonObj.unitInfoList.find(item => item.value === unitId)
      if (typeof unit === 'undefined') {
        return ''
      } else {
        return unit.text
      }
    },
    async getPriceListById (pId) {
      this.previousPrices = []
      this.unitLoad = true
      const result = await RestApi.getData(productionServiceBaseUrl, `${getPriceById}/` + pId)
      this.unitLoad = false
      // below code only for entry mode
      if (!this.id) {
        this.previousPrices = result.data
      }
      // the below code only for edit mode
      if (this.id) {
        this.previousPrices = result.data.filter((el, index) => index !== 0)
        this.formData.created_date = result.data[0].created_date
        const mapData = this.unitList.map(item => {
          const unit = result.data.find(item1 => item1.unit_id === parseInt(item.unit_id))
          if (typeof unit !== 'undefined') {
            item.value_price = unit.value_price
            item.dealer_price = unit.dealer_price
            item.recommended_price = unit.recommended_price
            item.retailer_price = unit.retailer_price
          } else {
            item.value_price = ''
            item.dealer_price = ''
            item.recommended_price = ''
            item.retailer_price = ''
          }
          return item
        })
        this.unitList = mapData
      }
    }
  }
}
</script>
